

var eGuardians = {};
eGuardians.apiservice = new function () {
    /**
     * 
     * @param {string} url
     * @param {string} method
     * @param {string} params
     * @param {function} callback
     */

    var callApi = function(url, method, params, callback, dataType){
        dataType = dataType || "json";
        $.ajax({
            url: url,
            method: method,
            data: params,
            dataType: dataType,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            async:false,
            beforeSend: function () {
                /* Laderosette oder fade effekte oder so */
            },
            statusCode: {
                404: function () {
                    console.error('404');
                },
                400: function (jqXHR, textStatus, errorThrown) {
                    console.error('Error 400');
                },
                412: function (jqXHR, textStatus, errorThrown) {
                    console.error('Error 412');
                },
                401: function () {
                    console.error('Error 401');
                },
                403: function () {
                    console.error('Error 403');
                },
                500: function (jqXHR, textStatus, errorThrown) {
                    console.error('Error 500');
                }
            },
            complete: function (jqXHR) {
         
                /* Laderosette oder fade beenden */
                //callback("complete");
                //var response = jqXHR.responseText ? $.parseJSON(jqXHR.responseText) : {};
                //callback(response);
            },
            success: function (jqXHR) {

                //var response = jqXHR.responseText ? $.parseJSON(jqXHR.responseText) : {};
                if(typeof callback === 'function') {
                    callback(jqXHR);
                }
                
            },
            fail: function(jqXHR)
            {
                console.log("fail")
                  var response = jqXHR.responseText ? $.parseJSON(jqXHR.responseText) : {};
                  if(typeof callback === 'function') {
                      callback(response);
                  }

            },
            error: function (jqXHR, textStatus, errorThrown) {
               console.log("isError")
                //var response = jqXHR ? $.parseJSON(jqXHR) : {};
                 var response = jqXHR.responseText ? $.parseJSON(jqXHR.responseText) : {};
                if(typeof callback === 'function') {
                     callback(response);
                }
                //messageServiceTranslations[response.data.exceptionCode]
            },
            always: function()
            {

            }
        });
    };
      /**
       * 
       * @param {string} url
       * @param {string} data
       * @param {function} callback
       */
      this.post = function( url, data, callback, dataType){
        dataType = dataType | "json";  
        callApi(url,'POST',data,function(response){
            if(typeof callback === 'function') {
                callback(response);
            }
        }, dataType);
      };   
      this.get = function( url, data, callback, dataType){
        dataType = dataType | "json"; 
        callApi(url,'GET',data,function(response){
            if(typeof callback === 'function') {
                callback(response);
            }
        });
      };
      this.put = function(url, data){
        this.callApi(url,'PUT',data);
      };
      this.delete = function( url, data, callback, dataType){
        dataType = dataType | "json"; 
        //this.callApi(url,'DELETE',data);
        callApi(url,'DELETE',data,function(response){
            if(typeof callback === 'function') {
                callback(response);
            }
        }, dataType);
      };
  }  

$(document).on('click', '.b2b-login-switch-register', function () {
    $('.b2b-wrap').toggleClass('show-b2b-register');
});

$(document).on('click','.link-right-modal-b2b',function(){
    $($(this).attr('href')).modal('show');
})
$(document).on('click','.show-b2b-register .form-check-label a[href="/datenschutzerklaerung/"]',function(){
    $('#policyrights').modal('show');
    return false;
})
$(document).on('click', 'a[href="#privacy-settings"]', function() {
    $('.cookie-bar').removeClass('out');
    return false;
});

if($('.matrix-wrap-variation').length>0){
    var variationsMatrixIds = [];
    $('.matrix-wrap-variation').each(function(){
        if(parseInt($(this).data('matrix-variationid')) != 0)
        variationsMatrixIds.push($(this).data('matrix-variationid'))
    });
    var variationsMatrixIdsHalf = [];
    if(variationsMatrixIds.length>49){
        var half_length = Math.ceil(variationsMatrixIds.length / 2); 
        variationsMatrixIdsHalf = variationsMatrixIds.splice(0,half_length);
    }
    var searchParams = {
        variationIds: variationsMatrixIds
    }
    if(variationsMatrixIds.length > 0){
        setMatrixData(searchParams);
    }
    
    if(variationsMatrixIdsHalf.length>0){
        var searchParams2 = {
            variationIds: variationsMatrixIdsHalf
        }
        setMatrixData(searchParams2);
    }
}

function setMatrixData(searchParams){

    eGuardians.apiservice.get('/rest/io/variations/',searchParams, function(response){ 
        $(response.data.documents).each(function(){

            var varition_this = this;
       
            var $elem = $('[data-matrix-variationid="'+varition_this.data.variation.id+'"]').closest('.mtrx-box');
            var instockTxt = " auf Lager";

            if($('.b2b-matrix-price-sizes').length > 0){
                setMatrixPrice($elem, this.data.prices.default.price, this.data.prices.rrp);
            }else{
                setMatrixPrice($elem.closest('.single-matrix-table'), this.data.prices.default.price, this.data.prices.rrp);
            }
            

            $elem.find('.stock-txt').html(this.data.stock.net + instockTxt);
            $elem.find('input').attr('data-stock', this.data.stock.net);
            $('.stock-txt').removeClass('lightui1-shimmer');
            if($(`.preview-images-hidden-container[data-variationimgid="${ varition_this.data.variation.id }"]`).length > 0){
                $(this.data.images.variation).each(function(){
                    var $previewImageContainer = $(`.preview-images-hidden-container[data-variationimgid="${ varition_this.data.variation.id }"]`);
                    
                    var dataZoomId = $previewImageContainer.closest('.single-matrix-table').find('.MagicZoom').attr('id');
                    var bigUrl = this.urlMiddle.replace("/middle/", "/full/");
                    var zoomPrevHtml = `<a data-zoom-id="${ dataZoomId }" href="${ bigUrl }" data-image="${ this.urlMiddle }">`;
                    zoomPrevHtml += `<img src="${ this.urlMiddle }">`;
                    zoomPrevHtml += `</a>`;
                    $(`.preview-images-hidden-container[data-variationimgid="${ varition_this.data.variation.id }"]`).append(zoomPrevHtml);
                    //$previewImageContainer.closest('.single-matrix-table').find('.MagicZoom').MagicZoom.start(dataZoomId);
                    
                    
                })
            }
        });
     
        window.setTimeout(function(){
            $('.MagicZoom').each(function(){
                
                MagicZoom.start($(this).attr('id'));
            })
            
        }, 1000);
    });
}
function setMatrixPrice($elem, price, rrp){
 
    $elem.find('.b2b-matrix-variation-price-single').html(price.formatted);
    $elem.find('.b2b-matrix-variation-price-single').attr('data-singleprice', price.value);

    if(rrp != null && rrp.price.value > price.value){
        $elem.find('.b2b-matrix-variation-price-rrp').html(rrp.price.formatted);
        $elem.find('.b2b-matrix-variation-price-rrp').attr('data-rrpprice', rrp.price.value);
        $elem.find('.b2b-matrix-variation-price').addClass('has-rrp');
        
    }
    $elem.find('.b2b-matrix-variation-price').removeClass('lightui1-shimmer');
}
$(document).on('change', '.matrix-wrap-variation .quantity-container input', function(event){   
    const value = $(this).val();
    var maxNumber = $(this).attr('data-stock');
    if (parseInt(value) > maxNumber) {
        $(this).val(maxNumber);
    }
    changeB2BPrice();
});
$(document).on('focus', '.matrix-wrap-variation .quantity-container input', function(event){   
    $(this).closest('.matrix-wrap-variation').removeClass('has-error');
    $(this).closest('.matrix-wrap-variation').find('.b2b-matrix-stock-error').remove();
});


function changeB2BPrice(){
    var sumPrice = 0;
    $('.matrix-wrap-variation .quantity-container input').each(function(){

        var quantityInput = parseInt($(this).val());
        if(quantityInput > 0){
            var inputPrice = 0;
            /*if($('.b2b-matrix-price-wohnen').length > 0){
                inputPrice = $(this).closest('.matrix-wrap-variation').find('.b2b-matrix-variation-price-single').attr('data-singleprice');
            }else{
                inputPrice = $(this).closest('.single-matrix-table').find('.b2b-matrix-variation-price-single').attr('data-singleprice');
            }*/
                inputPrice = $(this).closest('.matrix-wrap-variation').find('.b2b-matrix-variation-price-single').attr('data-singleprice');
            var sumPriceSingle = inputPrice * quantityInput;
            sumPrice += sumPriceSingle;
        }
    })
    

    if(sumPrice <=  0){
        sumPrice = "Bitte Menge wählen um Endpreis zu sehen";//parseFloat($('[data-eg-item-price]').attr('data-decimalprice'));
    } 
    
    $('.b2b-matrix-sum').html(sumPrice.toLocaleString("de-DE", {style:"currency", currency:"EUR"}));
}
var oneItemError = false;
$(document).on('click', '.btn-matrix-add-items', function() {
    
    oneItemError = false;
    var dataToAdd = [];
    $('[data-item-quantity]').each(function(){
        if($(this).val()>0){
            dataToAdd.push({
                variationId : $(this).parents('.matrix-wrap-variation').data('matrix-variationid'),
                quantity    : $(this).val(),
                template: 'Ceres::Basket.Basket'
            })
        }
    });
    if(dataToAdd.length > 0){
        $('.btn-matrix-add-items').addClass('is-load');
        $('.btn-matrix-add-items').attr('disabled', 'disabled');
        setTimeout(function(){
            addItems(dataToAdd, response => {
                if(response.data.exceptionCode == 111){
                    oneItemError = true;
                    $(`.matrix-wrap-variation[data-matrix-variationid="${response.data.placeholder.variationId}"]`).addClass('has-error');
                    $(`.matrix-wrap-variation[data-matrix-variationid="${response.data.placeholder.variationId}"]`).append(`<span class="b2b-matrix-stock-error">Max. Menge: ${response.data.placeholder.stock}</span>`)
                }
                
                console.log("Response received:", response);
            });
        },500);
    }
    

});

async function addItems(dataToAdd, callback) {
    const promises = dataToAdd.map(item => {
        return new Promise((resolve, reject) => {
            eGuardians.apiservice.post('/rest/io/basket/items/', item, function(response) {
                if (typeof callback === 'function') {
                    callback(response);
                }
                resolve();
            });
        });
    });

    try {
        await Promise.all(promises);
        console.log("All items have been added successfully.");
        if(oneItemError){
            window.CeresNotification.warn("Einige Artikel konnten nicht in den Warenkorb gelegt werden da die Menge überschritten wurde.");
        }else{
            $('.toggle-basket-preview')[0].click();
        }
        $('.btn-matrix-add-items').removeAttr('disabled', 'disabled');
        $('.btn-matrix-add-items').removeClass('is-load');
        
        
    } catch (error) {
        console.error("An error occurred:", error);
        $('.btn-matrix-add-items').removeAttr('disabled', 'disabled');
        $('.btn-matrix-add-items').removeClass('is-load');
        
    }
}

document.onreadystatechange = function () {
    if (document.readyState == "complete") {
        if($('.login-pw-modal').length > 0){
            $('.login-pw-modal').modal({
                backdrop: 'static',
                keyboard: false
            });
        }
    }
}
